import app from 'flarum/common/app';
// Resolve null quando o operador cancela.
export default function verificationPrompt(opts) {
  return new Promise(resolve => {
    app.modal.show(() => import(/* webpackChunkName: 'common/components/VerificationPromptModal', webpackMode: 'lazy-once' */ '../components/VerificationPromptModal'), {
      promptTitle: opts.title,
      noteLabel: opts.noteLabel,
      confirmLabel: opts.confirmLabel,
      withTier: !!opts.withTier,
      resolve
    });
  });
}
flarum.reg.add('ramon-verified', 'common/utils/verificationPrompt', verificationPrompt);flarum.reg.addChunkModule('640', '402', 'ramon-verified', 'common/components/VerificationPromptModal');flarum.reg.addChunkModule('640', '402', 'ramon-verified', 'common/components/VerificationPromptModal');